import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators, compose} from 'redux';
import {getModalProps} from '../../../redux/modules/modals/modals.selectors';

import styles from './ModalsDisplay.module.scss';

import BenifitsAndRestrictionsModal
  from '../../../containers/landing/BenifitsAndRestrictionsModal';
import WithholdingDisclosureModal
  from '../../../containers/TaxWithholding/WithHoldingDisclosureModal';
import StateDisclosureContentModal
  from '../../../containers/TaxWithholding/StateDisclosureContentModal';
import {
  AS_OF_ACCOUNT_BALANCES,
  AUTO_RMD_TOOLD_AND_RESTRICTIONS_MODAL,
  AUTOMATIC_TRANSACTION_DEFER_DELETE_FAIL,
  AUTOMATIC_TRANSACTION_DEFER_DELETE_SUCCESS,
  AUTOMATIC_TRANSACTION_DELETE,
  closeModal as closeModalAction,
  CONFIRM_MODAL,
  DELETE_MODAL,
  ESTIMATED_RATE_OF_RETURN,
  ESTIMATED_START_DATE_MODAL,
  EXIT_MODAL,
  FAILURE_MODAL,
  PAPERLESS_TERMS_MODAL,
  QCD_HISTORY_MODAL,
  REINVEST_TO_NEW_CORE,
  RMD_CALCULATOR_DISCLAIMER,
  RMD_PRIOR_YEAR_UNAVAILABLE,
  SELECTED_DATE_MODAL,
  STATES_DISCLOSURE_NOTES_MODAL,
  SUCCESS_MODAL,
  TAX_PAYER_MODAL,
  WITHHOLDING_DISCLOSURE_MODAL,
} from '../../../redux/modules/modals/modals.module';
import Modal from '../Modal/Modal';
import ExitModal from '../ExitModal/ExitModal';
import ConfirmModal from '../ConfirmModal/ConfirmModal';
import FailureModal from '../FailureModal/FailureModal';
import SuccessModal from '../SuccessModal/SuccessModal';
import DeleteModal from '../DeleteModal/DeleteModal';
import AutomaticDelete from '../AutomaticDelete/AutomaticDelete';
import DeleteFail from '../DeleteFail/DeleteFail';
import TaxPayerModal from '../TaxPayerModal/TaxPayerModal';
import EstimatedStartDateModal
  from '../../EstimatedStartDateModal/EstimatedStartDateModal';
import DeleteSuccess from '../DeleteSuccess/DeleteSuccess';
import ReInvestToNewCore
  from '../../../containers/ReInvestToNew/Core/ReInvestToNewModalCore';
import AsOfModal from '../AsOfModal/AsOfModal';
import CalculatorDisclaimerModal
  from '../../Calculator/Modal/CalculatorDisclaimerModal';
import UnavialablePriorYearRMDModal
  from '../../Calculator/Modal/UnavialablePriorYearRMDModal';
import EstimatedRateOfReturnModal
  from '../../Calculator/Modal/EstimatedRateOfReturnModal';
import {
  QCDSummaries
} from '../../DashboardLayout/QCD/QCDSummaries/QCDSummaries';
import SelectedDateModal from '../SelectedDateModal/SelectedDateModal';
import PaperlessTerms from '../TermsAndAgreements/PaperlessTerms';

const ModalsDisplay = ({ closeModal, modals, modalProps }) => (
  <div>
    <Modal
      onCloseClick={() => closeModal(AUTO_RMD_TOOLD_AND_RESTRICTIONS_MODAL)}
      show={modals[AUTO_RMD_TOOLD_AND_RESTRICTIONS_MODAL]}
      className={styles['tools-usages']}
    >
      <BenifitsAndRestrictionsModal
        onClose={() => closeModal(AUTO_RMD_TOOLD_AND_RESTRICTIONS_MODAL)}
      />
    </Modal>

    <Modal
      onCloseClick={() => closeModal(WITHHOLDING_DISCLOSURE_MODAL)}
      show={modals[WITHHOLDING_DISCLOSURE_MODAL]}
      className={styles['tools-usages']}
      clickOutsideCloses={false}
      showCloseButton={false}
    >
      <WithholdingDisclosureModal
        onClose={() => closeModal(WITHHOLDING_DISCLOSURE_MODAL)}
      />
    </Modal>

    <Modal
      onCloseClick={() => closeModal(REINVEST_TO_NEW_CORE)}
      show={modals[REINVEST_TO_NEW_CORE]}
      className={`${styles['tools-usages']} ${styles['reinvest-to-core']}`}
      clickOutsideCloses={false}
      showCloseButton={true}
    >
      <ReInvestToNewCore onClose={() => closeModal(REINVEST_TO_NEW_CORE)} />
    </Modal>

    <Modal
      onCloseClick={() => closeModal(TAX_PAYER_MODAL)}
      show={modals[TAX_PAYER_MODAL]}
      className={styles['tools-usages']}
      clickOutsideCloses={false}
      showCloseButton={false}
    >
      <TaxPayerModal onClose={() => closeModal(TAX_PAYER_MODAL)} />
    </Modal>
    <Modal
      onCloseClick={() => closeModal(STATES_DISCLOSURE_NOTES_MODAL)}
      show={modals[STATES_DISCLOSURE_NOTES_MODAL]}
      className={styles['tax-modal']}
    >
      <StateDisclosureContentModal
        onClose={() => closeModal(STATES_DISCLOSURE_NOTES_MODAL)}
      />
    </Modal>

    <Modal
      onCloseClick={() => closeModal(ESTIMATED_START_DATE_MODAL)}
      show={modals[ESTIMATED_START_DATE_MODAL]}
      className={styles['estimate-modal']}
    >
      <EstimatedStartDateModal {...modalProps[ESTIMATED_START_DATE_MODAL]} />
    </Modal>

    <Modal
      onCloseClick={() => closeModal(SELECTED_DATE_MODAL)}
      show={modals[SELECTED_DATE_MODAL]}
      className={styles['estimate-modal']}
    >
      <SelectedDateModal
        {...modalProps[SELECTED_DATE_MODAL]}
        onClose={() => closeModal(SELECTED_DATE_MODAL)}
      />
    </Modal>

    <Modal
      onCloseClick={() => closeModal(RMD_CALCULATOR_DISCLAIMER)}
      show={modals[RMD_CALCULATOR_DISCLAIMER]}
      className={styles['estimate-modal']}
      showCloseButton={true}
      clickOutsideCloses={false}
    >
      <CalculatorDisclaimerModal
        onClose={() => closeModal(RMD_CALCULATOR_DISCLAIMER)}
      />
    </Modal>

    <Modal
      onCloseClick={() => closeModal(RMD_PRIOR_YEAR_UNAVAILABLE)}
      show={modals[RMD_PRIOR_YEAR_UNAVAILABLE]}
      className={styles['estimate-modal']}
      showCloseButton={false}
      clickOutsideCloses={false}
    >
      <UnavialablePriorYearRMDModal
        onClose={() => closeModal(RMD_PRIOR_YEAR_UNAVAILABLE)}
      />
    </Modal>

    <Modal
      onCloseClick={() => closeModal(ESTIMATED_RATE_OF_RETURN)}
      show={modals[ESTIMATED_RATE_OF_RETURN]}
      className={styles['estimate-modal']}
      showCloseButton={false}
      clickOutsideCloses={false}
    >
      <EstimatedRateOfReturnModal
        onClose={() => closeModal(ESTIMATED_RATE_OF_RETURN)}
      />
    </Modal>
    <Modal
      onCloseClick={() => closeModal(EXIT_MODAL)}
      show={modals[EXIT_MODAL]}
      className={styles['exit-modal']}
    >
      <ExitModal
        {...modalProps}
        {...modalProps[EXIT_MODAL]}
        onClose={() => closeModal(EXIT_MODAL)}
      />
    </Modal>

    <Modal
      onCloseClick={() => closeModal(CONFIRM_MODAL)}
      show={modals[CONFIRM_MODAL]}
      className={styles['confirm_modal']}
    >
      <ConfirmModal
        {...modalProps}
        {...modalProps[CONFIRM_MODAL]}
        onClose={() => closeModal(CONFIRM_MODAL)}
      />
    </Modal>

    <Modal
      onCloseClick={() => closeModal(FAILURE_MODAL)}
      show={modals[FAILURE_MODAL]}
      className={styles['failure-modal']}
      showCloseButton={false}
      clickOutsideCloses={false}
    >
      <FailureModal
        {...modalProps}
        {...modalProps[FAILURE_MODAL]}
        onClose={() => closeModal(FAILURE_MODAL)}
      />
    </Modal>

    <Modal
      onCloseClick={() => closeModal(SUCCESS_MODAL)}
      show={modals[SUCCESS_MODAL]}
      className={styles['confirm-modal']}
      showCloseButton={false}
      clickOutsideCloses={false}
    >
      <SuccessModal
        {...modalProps}
        {...modalProps[SUCCESS_MODAL]}
        onClose={() => closeModal(SUCCESS_MODAL)}
      />
    </Modal>

    <Modal
      onCloseClick={() => closeModal(AS_OF_ACCOUNT_BALANCES)}
      show={modals[AS_OF_ACCOUNT_BALANCES]}
      className={styles['delete-modal']}
    >
      <AsOfModal
        {...modalProps[AS_OF_ACCOUNT_BALANCES]}
        onClose={() => closeModal(AS_OF_ACCOUNT_BALANCES)}
      />
    </Modal>
    <Modal
      onCloseClick={() => closeModal(DELETE_MODAL)}
      show={modals[DELETE_MODAL]}
      className={styles['delete-modal']}
    >
      <DeleteModal
        {...modalProps}
        {...modalProps[DELETE_MODAL]}
        onClose={() => closeModal(DELETE_MODAL)}
      />
    </Modal>
    <Modal
      onCloseClick={() => closeModal(AUTOMATIC_TRANSACTION_DEFER_DELETE_FAIL)}
      show={modals[AUTOMATIC_TRANSACTION_DEFER_DELETE_FAIL]}
      className={styles['delete-modal-fail']}
    >
      <DeleteFail
        {...modalProps}
        {...modalProps[AUTOMATIC_TRANSACTION_DEFER_DELETE_FAIL]}
        onClose={() => closeModal(AUTOMATIC_TRANSACTION_DEFER_DELETE_FAIL)}
      />
    </Modal>
    <Modal
      onCloseClick={() =>
        closeModal(AUTOMATIC_TRANSACTION_DEFER_DELETE_SUCCESS)
      }
      show={modals[AUTOMATIC_TRANSACTION_DEFER_DELETE_SUCCESS]}
      className={styles['delete-modal-sucess']}
    >
      <DeleteSuccess
        {...modalProps}
        {...modalProps[AUTOMATIC_TRANSACTION_DEFER_DELETE_SUCCESS]}
        onClose={() => closeModal(AUTOMATIC_TRANSACTION_DEFER_DELETE_SUCCESS)}
      />
    </Modal>
    <Modal
      onCloseClick={() => closeModal(AUTOMATIC_TRANSACTION_DELETE)}
      show={modals[AUTOMATIC_TRANSACTION_DELETE]}
      className={styles['delete-modal-automatic']}
    >
      <AutomaticDelete
        {...modalProps}
        {...modalProps[AUTOMATIC_TRANSACTION_DELETE]}
        onClose={() => closeModal(AUTOMATIC_TRANSACTION_DELETE)}
      />
    </Modal>
    <Modal
      onCloseClick={() => closeModal(QCD_HISTORY_MODAL)}
      show={modals[QCD_HISTORY_MODAL]}
      className={styles['delete-modal-automatic']}
      showBottomBar={true}
    >
      <QCDSummaries onClose={() => closeModal(QCD_HISTORY_MODAL)} />
    </Modal>
    <Modal
      onCloseClick={() => closeModal(PAPERLESS_TERMS_MODAL)}
      show={modals[PAPERLESS_TERMS_MODAL]}
      className={styles['tools-usages']}
      clickOutsideCloses={false}
      showCloseButton={true}
    >
      <PaperlessTerms
        onClose={() => closeModal(PAPERLESS_TERMS_MODAL)}
      />
    </Modal>
  </div>
);

const mapStateToProps = (state) => {
  const { modals } = state;
  return {
    modals,
    modalProps: getModalProps(state),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ closeModal: closeModalAction }, dispatch);

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  ModalsDisplay
);
